import { Table } from '@tanstack/table-core';
import { DataGridRowProps } from '@components/primitives/dataGrid/DataGrid';

const useDataGridColumnAutoSizer = () => {
    const getMaxColumnWidth = (columnId: string, padding = 16) => {
        const headerLabel = document.querySelector(`[data-measure-head="${columnId}"]`) as HTMLElement;
        let maxWidth = headerLabel.offsetWidth;

        const parent = headerLabel.parentNode as HTMLElement;
        if (parent && parent.classList.contains('dataGrid__label')) {
            const styles = window.getComputedStyle(parent);
            const paddingRight = parseFloat(styles.paddingRight);
            maxWidth += paddingRight;
        }

        const cells = document.querySelectorAll(`[data-measure-column="${columnId}"]`);
        cells.forEach((cell) => {
            const el = cell as HTMLElement;
            maxWidth = Math.max(maxWidth, el.offsetWidth);
        });

        return maxWidth + padding;
    };

    const autoSizeColumn = <TData extends DataGridRowProps>(table: Table<TData>, columnId: string) => {
        const newSize = getMaxColumnWidth(columnId);

        table.setColumnSizing((state) => {
            return {
                ...state,
                [columnId]: newSize,
            };
        });
    };

    return {
        autoSizeColumn,
    };
};

export default useDataGridColumnAutoSizer;
